import React from 'react';
import { Button, Col, Input, Row, Form, InputNumber, Typography, Radio } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

const SpoFields = ({ readOnly, quote }) => {
  const { Title } = Typography;
  const keywords = quote.payload.keywords || [];
  return (
    <>
      <Form.Item 
        name={["payload", "business_name"]} 
        label="Business Name"
        rules={[{ required: true, message: 'Please enter business name' }]}
      >
        <Input disabled={readOnly} />
      </Form.Item>

      <Form.Item 
        name={["payload", "business_website"]} 
        label="Business Website"
        rules={[
          { required: true, message: 'Please enter business website' }
        ]}
      >
        <Input disabled={readOnly} placeholder="https://example.com" />
      </Form.Item>

      <Form.Item 
        name={["payload", "locations"]} 
        label="Locations"
        rules={[{ required: true, message: 'Please enter locations' }]}
      >
        <Input.TextArea 
          disabled={readOnly} 
          placeholder="Enter locations, one per line"
          rows={3}
        />
      </Form.Item>

      <Form.Item 
        name={["payload", "services"]} 
        label="Services"
        rules={[{ required: true, message: 'Please enter services' }]}
      >
        <Input.TextArea 
          disabled={readOnly} 
          placeholder="Enter services, one per line"
          rows={3}
        />
      </Form.Item>

      <Form.Item 
        name={["payload", "max_clicks"]} 
        label="Max Clicks per Month"
        rules={[
          { required: true, message: 'Please enter max clicks per month' },
          { type: 'number', min: 0, message: 'Clicks must be a positive number' }
        ]}
      >
        <InputNumber 
          disabled={readOnly}
          style={{ width: '100%' }}
          formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
          parser={value => value.replace(/\$\s?|(,*)/g, '')}
        />
      </Form.Item>

      <Form.Item 
        name={["payload", "autocomplete_term"]} 
        label="Autocomplete Term"
        rules={[{ required: true, message: 'Please enter autocomplete term' }]}
      >
        <Input disabled={readOnly} />
      </Form.Item>
      
      <Form.Item 
        name={["payload", "type_of_order"]}
        label="Type of Order"
        rules={[{ required: true, message: 'Please select the type of order' }]}
      >
        <Radio.Group disabled={readOnly}>
          <Radio value="national">National</Radio>
          <Radio value="local">Local</Radio>
        </Radio.Group>
      </Form.Item>
      
      <Title level={4}>Keywords</Title>
      <Form.List name={["payload", "keywords"]} label="Keywords" >
        {(fields, { add, remove }) => (
          <>
            {fields.map((field, index) => (
              <Form.Item
                noStyle
                shouldUpdate
              >
                {() => (
                  <>
                    <Row gutter={16}>
                      <Col span={22}>
                        <Form.Item
                          label="Keyword"
                          name={[index, "label"]}
                          rules={[{ required: true, message: 'Please enter a label' }]}
                          fieldKey={[field.name, "label"]}
                        >

                          <Input type="text"
                            disabled={readOnly}
                          />

                        </Form.Item>
                      </Col>

                      <Col span={2} style={{ marginTop: '2.2rem' }}>
                        {!readOnly &&
                          (keywords === null || keywords[index] === undefined)
                          && <MinusCircleOutlined onClick={() => remove(field.name)} />
                        }
                      </Col>
                    </Row>
                  </>
                )}
              </Form.Item>

            ))}
            {!readOnly &&
              <Form.Item>
                <Button
                  type="dashed"
                  onClick={() => add({ kind: 'custom' })}
                  block
                  icon={<PlusOutlined />}
                >
                  Add another line item
              </Button>
              </Form.Item>
            }
          </>
        )}
      </Form.List>
    </>
  );
};

export default SpoFields; 